import React, { useContext, useEffect, useState } from 'react'
import { Button, IconButton, Stack, Switch, Typography } from '@mui/material'
import { collection, query, orderBy, onSnapshot, deleteDoc, doc, getDoc, getDocs, updateDoc, where } from "firebase/firestore"
import { AuthContext } from '../../../AuthProvider';
import { DataGrid, GridActionsCellItem, GridToolbar, frFR } from '@mui/x-data-grid';
import { database } from '../../../firebaseConfig';
import dateFormat, { masks } from "dateformat";
import AddTaskIcon from '@mui/icons-material/AddTask';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Link } from 'react-router-dom';
import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import { green } from '@mui/material/colors';
import AccessDinied from '../../../components/AccessDinied';
const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#1890ff',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));

function Reservation() {
  const [attente, setAttente] = useState(false)
  const { user } = useContext(AuthContext);
  const [reservations, setReservations] = useState([])
  const [loadingData, setLoadingData] = useState(true)

  const columns = [
    { field: 'nom_chu', headerName: 'CHU', width: 170 },
    { field: 'reference', headerName: 'Réference' },
    { field: 'nom_service', headerName: 'Service', width: 170 },
    { field: 'nom', headerName: 'Nom' },
    { field: 'prenom', headerName: 'Prénom' },
    { field: 'contact', headerName: 'Contact' },
    { field: 'email', headerName: 'Email' },
    {
      field: 'date_rdv',
      headerName: 'Date',
    },
    { field: 'heure_rdv', headerName: 'Heure' },
    { field: 'lieu', headerName: 'Lieu' },
    {
      field: 'status', headerName: 'Status',
      renderCell: (params) => {
        return (
          <Typography color={params.value ? 'green' : comparaisonDate(params.row.date_rdv) ? 'primary' : 'error'} >
            {params.value ? 'Confirmé' : comparaisonDate(params.row.date_rdv) ? 'En attente' : 'Expiré'}
          </Typography>
        )
      }
    },
    {
      field: 'actions',
      headerName: 'Actions',
      cellClassName: 'actions',
      sortable: false,
      hideable: false,
      filterable: false,
      disableExport: true,
      renderCell: ({ id, row }) => {
        if (!row.status && comparaisonDate(row.date_rdv)) {
          return (
            <IconButton aria-label='Confirmer' color="success" onClick={() => {
              updateRdv(id, row)
            }}>
              <AddTaskIcon />
            </IconButton>
          )
        }
        else if (!row.status && !comparaisonDate(row.date_rdv)) {
          return (
            <IconButton aria-label='Supprimer' color="error" onClick={() => {
              handleDelete(id)
            }}>
              <DeleteIcon />
            </IconButton>
          )
        }

      }
    }
  ]
  useEffect(() => {
    const q = query(collection(database, 'reservation'), orderBy('reference', 'desc'))
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      setLoadingData(true)
      const rdvsData = querySnapshot.docs.map(async (rdvDoc) => {
        const rdvData = rdvDoc.data()
        const chuId = rdvData.chu_id
        const serviceId = rdvData.service_id
        const chuDocRef = doc(database, 'chu', chuId);
        const chuDocSnapshot = await getDoc(chuDocRef);
        rdvData.nom_chu = chuDocSnapshot.data().nom_chu
        if (serviceId != null && serviceId != '') {
          const serviceDocRef = doc(database, 'service', serviceId);
          const serviceDocSnapshot = await getDoc(serviceDocRef);
          rdvData.nom_service = serviceDocSnapshot.data().nom_service
          const dateConvert = new Date(rdvData.date_rdv)
          if(rdvData.date_rdv !=''){
            rdvData.date_rdv = dateConvert.toLocaleDateString('fr-FR')
          }
        }
        return {
          id: rdvDoc.id,
          ...rdvData
        }
      })
      Promise.all(rdvsData).then((modifiedRdvs) => {
        const rdvStatus = modifiedRdvs.filter((elem) => {
          return elem.status == !attente && elem.service_id != "" && elem.service_id != null
        })
        setReservations(rdvStatus);
        if (user.chu_id) {
          const rdvs = rdvStatus.filter((elem) => {
            return elem.chu_id == user.chu_id
          })
          setReservations(rdvs);
        }
        setLoadingData(false)

      });
    })
    return () => {
      unsubscribe()
    };
  }, [attente])
  const comparaisonDate = (dateRdv) => {
    var dateNow = dateFormat(new Date(), "yyyy-mm-dd")
    var date1 = new Date(dateRdv);
    var date2 = new Date(dateNow);
    return date2 <= date1
  }

  const updateRdv = async (id, row) => {
    const reservationDocRef = doc(database, 'reservation', id)
    try {
      await updateDoc(reservationDocRef, {
        reference: row.reference,
        service_id: row.service_id,
        chu_id: row.chu_id,
        date_rdv: row.date_rdv,
        heure_rdv: row.heure_rdv,
        nom: row.nom,
        prenom: row.prenom,
        age: row.age,
        genre: row.genre,
        email: row.email,
        contact: row.contact,
        status: true,
        lieu: row.lieu
      })
    } catch (err) {
      alert(err)
    }
  }
  const handleDelete = async (id) => {
    const reservationDocRef = doc(database, 'reservation', id)
    try {
      await deleteDoc(reservationDocRef)
    } catch (err) {
      alert(err)
    }
  }

  if (user.type != 'Utilisateur') {
    return <AccessDinied />
  }
  return (
    <div style={{ width: '100%', flexGrow: 1, overflow: 'hidden' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button component={Link} to="/admin/addReservation" variant="contained" size='small' color='primary' startIcon={<AddCircleOutlineIcon />}>
          Ajouter
        </Button>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography color={!attente ? green[600] : ''}>Confirmé</Typography>
          <AntSwitch checked={attente} onChange={(e) => {
            setAttente(e.target.checked)
          }} inputProps={{ 'aria-label': 'ant design' }} />
          <Typography color={attente ? 'primary' : ''} >En attente</Typography>
        </Stack>
      </div>
      <div style={{ width: '100%', height: 450 }}>
        <DataGrid
          rowSelection={false}
          sx={{ maxHeight: 450, marginTop: 2 }}
          columns={columns}
          rows={reservations}

          loading={loadingData}
          localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
          slots={{
            toolbar: GridToolbar,
            loadingOverlay: LinearProgress,
          }}
          slotProps={{
            toolbar: {
              printOptions: { disableToolbarButton: true },
              csvOptions: {
                fileName: 'rendez_vous_csv_' + dateFormat(new Date(), 'yyyymmddHHMMss'),
                delimiter: ',',
                utf8WithBom: true,
              }
            }
          }}
        />
      </div>
    </div>
  )
}

export default Reservation